/**
 * Hand-off to the deployment that owns an account: the backend's source boundary answers
 * `{ redirect }` when a gov account reaches apps.wrks.ai (or a wrks account the gov app).
 *
 * The cross-origin navigation stays pending until that host answers, and any later navigation of
 * this document cancels it. That is how gov users entering the AWS app ended on
 * OAUTH_LOGIN_REQUIRED: `/auth` started the hand-off, then routed to `/`, whose OAuth auto-start
 * (`prompt=none` at the wrks gateway) replaced it. So a hand-off
 * - replaces the history entry (going back would only bounce again),
 * - stops the OAuth auto-start and the 401 redirect for the rest of this document,
 * - returns a promise that never settles, so the caller acts on nothing.
 */
let handingOff = false

export function handOffToDeployment(url: string): Promise<never> {
  handingOff = true
  window.location.replace(url)
  return new Promise<never>(() => {})
}

/** True once a hand-off started: nothing else may navigate this document. */
export function isHandingOff(): boolean {
  return handingOff
}
